export class RepairDetails {
  public premisesAddress?: any = {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    addressLine5: '',
    postcode: '',
  }
  public customerName?: any = {
    title: '',
    givenName: '',
    surname: '',
  }
  public repairLocationId: string = ''
  public description: string = ''
  public isEmergency: boolean = false
  public premisesTypeId: string = ''
  public additionalInformation: string = ''
  public premisesUniqueReference: string = ''
  public sorCode?: string
  public completedStep?: number
  public assetIdentifier: string = ''

}

export class CreatedRepair {
  public chargeCustomer?: boolean = false
  public repairCauseId?: number = 0
  public riskToHumanLife?: boolean = false
  public crimeReferenceNumber?: string | null = null
  public completedStep?: number
}

export class RepairContact {
  public id: string = ''
  public reportedById?: string
  public notifyAll?: boolean
  public reporterContactDetails?: {
    name: null
    contactNumber: null
    organisation: null
    reporterToBeContacted: true
  }
  public staffContactEmails?: string[]
  public reportingMethodId?: string
}

export enum RepairReporterId {
  Customer = 1,
  FriendOrfamily = 2,
  MemberOfStaff = 3,
  SupportWorker = 4,
  Other = 5,
}

export enum RepairPriority {
  NextAvailable = "Next Available",
  Emergency = "Emergency",
  EmergencyOOH = "Emergency (OOH)",
  DM14Days = "Damp and Mould -14 days",
  NextAvailable14Days = "Next Available -14 days",
  DM24Hours = "Damp and Mould -24 hours",
  NextAvailableRecallRC = 'Next Available (Recall)',
  DampAndMouldLowRisk = 'Damp and Mould Low -28 days',
  DampAndMouldSignificant = 'Damp and Mould Significant -14 days',
}

export enum RepairPriorityCode {
  Emergency = 'EME',
  NextAvailable = 'NA',
  DampAndMould = 'DM',
  DampAndMouldEmergency = 'DME',
  V14 = 'V14',
  OutOfHours = 'OOH',
  NextAvailableRecallRC = 'RC',
  NextAvailableRecallRRC = 'RRC',
  DampAndMouldLowRisk = 'DML',
  DampAndMouldSignificant = 'DMS',
  AWAABSLAWEMERGENCY='AWE',
  AWAABSLAWSIGNIFICANT ='AWS',
  AWAABSLAWLOW='AWL'
}

export enum AddressType {
  Email = "email",
  Postal = "postal",
}

export enum CasePriority {
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW'
}

export const RepairPriorityToCodeMap: Record<RepairPriority, RepairPriorityCode> = {
  [RepairPriority.NextAvailable]: RepairPriorityCode.NextAvailable,
  [RepairPriority.Emergency]: RepairPriorityCode.Emergency,
  [RepairPriority.EmergencyOOH]: RepairPriorityCode.Emergency,
  [RepairPriority.DM14Days]: RepairPriorityCode.DampAndMould,
  [RepairPriority.NextAvailable14Days]: RepairPriorityCode.V14,
  [RepairPriority.DM24Hours]: RepairPriorityCode.DampAndMouldEmergency,
  [RepairPriority.NextAvailableRecallRC]: RepairPriorityCode.NextAvailableRecallRC || RepairPriorityCode.NextAvailableRecallRRC,
  [RepairPriority.DampAndMouldLowRisk]: RepairPriorityCode.DampAndMouldLowRisk,
  [RepairPriority.DampAndMouldSignificant]: RepairPriorityCode.DampAndMouldSignificant
};
